export var regex = {
    personName: new RegExp('^\\p{L}+(?:[\'\\s-]\\p{L}+)*$', 'u'),
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
};
